import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import NO_IMAGE from "../../assets/images/no-image-icon.png";
import countries from "helpers/countries";
import i18n from "i18next";

interface Option {
  label: string | any;
  value: string;
}
interface DropdownOptionProps {
  name?: string;
  initialValue?: undefined | any;
  dataList?: any[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  classNamePrefix?: string;
  isHasOptionAll?: boolean;
  optionAll?: undefined | Option;
  isClearable?: boolean;
  isAllCountry?: boolean;
}

const DropdownCountries = ({
  name = "country",
  initialValue,
  onChangeSelect,
  dataList = [],
  placeholder,
  disabled = false,
  className = "",
  classNamePrefix = "",
  isHasOptionAll = false,
  optionAll,
  isClearable = false,
  isAllCountry = false
}: DropdownOptionProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  useEffect(() => {
    let countriesFilter = [];
    if(isAllCountry) {
      countriesFilter = countries;
    }else {
      countriesFilter = dataList.map((el) => {
        var dataNew = { ...el };
        countries.filter((f: any) => {
          if (f.code === el.country_code) {
            dataNew = {
              ...el,
              flags: f?.flags,
              name_korea: f?.name_korea,
              name: f?.name,
              code: f?.code
            };
          }
          return f.code === el.country_code;
        });
        return dataNew;
      });
    }

    const resultOptions =
      countriesFilter?.map((a: any) => {
        return {
          value: String(a?.code),
          label: (
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  height: "24px",
                  width: "24px",
                  overflow: "hidden",
                  borderRadius: "15px",
                  objectFit: "cover",
                  backgroundColor: "#eaeaea",
                  zIndex: 99,
                }}
              >
                <img
                  src={a?.flags || NO_IMAGE}
                  alt={a?.name}
                  height={24}
                  width={24}
                  style={{
                    minWidth: "24px",
                    overflow: "hidden",
                    borderRadius: "50%",
                    objectFit: "cover",
                    backgroundColor: "#eaeaea",
                  }}
                />
              </div>
              {a?.name}
            </div>
          ),
          data: a,
        };
      }) || ([] as Option[]);

    const result: any = isHasOptionAll
      ? [optionAll].concat(resultOptions)
      : resultOptions;
    setOptions((_prev: any) => result);


  }, [JSON.stringify(dataList), i18n?.language]);

  const filterOption = (option: any, inputValue: any) => {
    const plainLabel = `${option.data?.data?.name_korea} ${option.data?.data?.name}`;
    return plainLabel?.toLowerCase()?.includes(inputValue.toLowerCase());
  };

  return (
    <div className="position-relative">
      <Select
        options={options}
        name={name}
        value={(initialValue || isHasOptionAll) ? options.find((item: any) => item.value === initialValue) : null}
        isDisabled={disabled}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder || ""}</div>}
        loadingMessage={() => <div>{t("Loading")}...</div>}
        noOptionsMessage={() => <div>{t("No Options")}</div>}
        className={className}
        classNamePrefix={classNamePrefix}
        isClearable={isClearable}
        filterOption={filterOption}
      />
    </div>
  );
};

export default DropdownCountries;
